'use strict';

/*@ngInject*/
module.exports = function (publicUsersService, $q, $timeout) {
	return {
		scope: {
			userId: '@',
			baseUrl: '@'
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function controller() {
			var vm = this;

			vm.$onInit = function () {
				vm.passwordPattern = publicUsersService.passwordPattern;
				vm.resetPasswordError = false;
				vm.resetPasswordSuccess = false;
				vm.userData = { id: vm.userId };
				vm.id = document.getElementById('password1');
			};

			vm.submit = function () {
				validateForm().then(function () {
					publicUsersService.setNewPassword(vm.userData).then(function (res) {
						vm.message = res.data;
						if (res.data === 'passwords_are_different') {
							vm.resetPasswordError = true;
						} else {
							vm.resetPasswordSuccess = true;
							$timeout(function () {
								return document.location.href = vm.baseUrl;
							}, 2000);
						}
					});
				});
			};

			function validateForm() {
				return $q(function (resolve, reject) {
					vm.showErrors = false;
					if (vm.publicUserForm.$invalid) {
						vm.showErrors = true;
						reject();
					} else {
						resolve();
					}
				});
			}
		},
		template: require('./reset-password.directive.html')
	};
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/reset-password.directive.js
 **/